"use strict";

var _createForOfIteratorHelper = require("/Users/michael/Documents/michaelw54.github.io/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/Users/michael/Documents/michaelw54.github.io/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/michael/Documents/michaelw54.github.io/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Canvas = void 0;

var Utils_1 = require("../Utils");

var Canvas = /*#__PURE__*/function () {
  function Canvas(container) {
    _classCallCheck(this, Canvas);

    this.container = container;
    this.size = {
      height: 0,
      width: 0
    };
    this.context = null;
    this.generatedCanvas = false;
  }

  _createClass(Canvas, [{
    key: "init",
    value: function init() {
      this.resize();
      var options = this.container.options;
      var cover = options.backgroundMask.cover;
      var color = cover.color;
      var trail = options.particles.move.trail;
      var coverRgb = Utils_1.ColorUtils.colorToRgb(color);
      this.coverColor = coverRgb !== undefined ? {
        r: coverRgb.r,
        g: coverRgb.g,
        b: coverRgb.b,
        a: cover.opacity
      } : undefined;
      this.trailFillColor = Utils_1.ColorUtils.colorToRgb(trail.fillColor);
      this.initBackground();
      this.paint();
    }
  }, {
    key: "loadCanvas",
    value: function loadCanvas(canvas, generatedCanvas) {
      var _a;

      if (!canvas.className) {
        canvas.className = Utils_1.Constants.canvasClass;
      }

      if (this.generatedCanvas) {
        (_a = this.element) === null || _a === void 0 ? void 0 : _a.remove();
      }

      this.generatedCanvas = generatedCanvas !== null && generatedCanvas !== void 0 ? generatedCanvas : false;
      this.element = canvas;
      this.size.height = canvas.offsetHeight;
      this.size.width = canvas.offsetWidth;
      this.context = this.element.getContext("2d");
      this.container.retina.init();
      this.initBackground();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _a;

      if (this.generatedCanvas) {
        (_a = this.element) === null || _a === void 0 ? void 0 : _a.remove();
      }

      if (this.context) {
        Utils_1.CanvasUtils.clear(this.context, this.size);
      }
    }
  }, {
    key: "resize",
    value: function resize() {
      if (!this.element) {
        return;
      }

      this.element.width = this.size.width;
      this.element.height = this.size.height;
    }
  }, {
    key: "paint",
    value: function paint() {
      var options = this.container.options;

      if (!this.context) {
        return;
      }

      if (options.backgroundMask.enable && options.backgroundMask.cover && this.coverColor) {
        Utils_1.CanvasUtils.clear(this.context, this.size);
        this.paintBase(Utils_1.ColorUtils.getStyleFromRgb(this.coverColor, this.coverColor.a));
      } else {
        this.paintBase();
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      var options = this.container.options;
      var trail = options.particles.move.trail;

      if (options.backgroundMask.enable) {
        this.paint();
      } else if (trail.enable && trail.length > 0 && this.trailFillColor) {
        this.paintBase(Utils_1.ColorUtils.getStyleFromRgb(this.trailFillColor, 1 / trail.length));
      } else if (this.context) {
        Utils_1.CanvasUtils.clear(this.context, this.size);
      }
    }
  }, {
    key: "drawLinkTriangle",
    value: function drawLinkTriangle(p1, link1, link2) {
      var _a, _b;

      var container = this.container;
      var options = container.options;
      var p2 = link1.destination;
      var p3 = link2.destination;
      var triangleOptions = p1.particlesOptions.links.triangles;
      var opacityTriangle = (_a = triangleOptions.opacity) !== null && _a !== void 0 ? _a : (link1.opacity + link2.opacity) / 2;
      var pos1 = p1.getPosition();
      var pos2 = p2.getPosition();
      var pos3 = p3.getPosition();
      var ctx = this.context;

      if (!ctx) {
        return;
      }

      var colorTriangle = Utils_1.ColorUtils.colorToRgb(triangleOptions.color);

      if (!colorTriangle) {
        var linksOptions = p1.particlesOptions.links;
        var linkColor = linksOptions.id !== undefined ? container.particles.linksColors.get(linksOptions.id) : container.particles.linksColor;

        if (linkColor === Utils_1.Constants.randomColorValue) {
          colorTriangle = Utils_1.ColorUtils.getRandomRgbColor();
        } else if (linkColor === "mid") {
          var sourceColor = p1.getFillColor();
          var destColor = p2.getFillColor();

          if (sourceColor && destColor) {
            colorTriangle = Utils_1.ColorUtils.mix(sourceColor, destColor, p1.size.value, p2.size.value);
          } else {
            var hslColor = sourceColor !== null && sourceColor !== void 0 ? sourceColor : destColor;

            if (!hslColor) {
              return;
            }

            colorTriangle = Utils_1.ColorUtils.hslToRgb(hslColor);
          }
        } else {
          colorTriangle = linkColor;
        }
      }

      var width = (_b = p1.linksWidth) !== null && _b !== void 0 ? _b : container.retina.linksWidth;
      Utils_1.CanvasUtils.drawLinkTriangle(ctx, width, pos1, pos2, pos3, options.backgroundMask.enable, colorTriangle, opacityTriangle);
    }
  }, {
    key: "drawLinkLine",
    value: function drawLinkLine(p1, link) {
      var _a, _b, _c;

      var container = this.container;
      var options = container.options;
      var p2 = link.destination;
      var opacity = link.opacity;
      var pos1 = p1.getPosition();
      var pos2 = p2.getPosition();
      var ctx = this.context;

      if (!ctx) {
        return;
      }

      var colorLine;
      var twinkle = p1.particlesOptions.twinkle.lines;

      if (twinkle.enable) {
        var twinkleFreq = twinkle.frequency;
        var twinkleRgb = Utils_1.ColorUtils.colorToRgb(twinkle.color);
        var twinkling = Math.random() < twinkleFreq;

        if (twinkling && twinkleRgb !== undefined) {
          colorLine = twinkleRgb;
          opacity = twinkle.opacity;
        }
      }

      if (!colorLine) {
        var linksOptions = p1.particlesOptions.links;
        var linkColor = linksOptions.id !== undefined ? container.particles.linksColors.get(linksOptions.id) : container.particles.linksColor;

        if (linkColor === Utils_1.Constants.randomColorValue) {
          colorLine = Utils_1.ColorUtils.getRandomRgbColor();
        } else if (linkColor === "mid") {
          var sourceColor = (_a = p1.getFillColor()) !== null && _a !== void 0 ? _a : p1.getStrokeColor();
          var destColor = (_b = p2.getFillColor()) !== null && _b !== void 0 ? _b : p2.getStrokeColor();

          if (sourceColor && destColor) {
            colorLine = Utils_1.ColorUtils.mix(sourceColor, destColor, p1.size.value, p2.size.value);
          } else {
            var hslColor = sourceColor !== null && sourceColor !== void 0 ? sourceColor : destColor;

            if (!hslColor) {
              return;
            }

            colorLine = Utils_1.ColorUtils.hslToRgb(hslColor);
          }
        } else {
          colorLine = linkColor;
        }
      }

      var width = (_c = p1.linksWidth) !== null && _c !== void 0 ? _c : container.retina.linksWidth;
      Utils_1.CanvasUtils.drawLinkLine(ctx, width, pos1, pos2, p1.particlesOptions.links.distance, container.canvas.size, p1.particlesOptions.links.warp, options.backgroundMask.enable, colorLine, opacity, p1.particlesOptions.links.shadow);
    }
  }, {
    key: "drawConnectLine",
    value: function drawConnectLine(p1, p2) {
      var _a;

      var lineStyle = this.lineStyle(p1, p2);

      if (!lineStyle) {
        return;
      }

      var ctx = this.context;

      if (!ctx) {
        return;
      }

      var pos1 = p1.getPosition();
      var pos2 = p2.getPosition();
      Utils_1.CanvasUtils.drawConnectLine(ctx, (_a = p1.linksWidth) !== null && _a !== void 0 ? _a : this.container.retina.linksWidth, lineStyle, pos1, pos2);
    }
  }, {
    key: "drawGrabLine",
    value: function drawGrabLine(particle, lineColor, opacity, mousePos) {
      var _a;

      var container = this.container;
      var ctx = container.canvas.context;

      if (!ctx) {
        return;
      }

      var beginPos = particle.getPosition();
      Utils_1.CanvasUtils.drawGrabLine(ctx, (_a = particle.linksWidth) !== null && _a !== void 0 ? _a : container.retina.linksWidth, beginPos, mousePos, lineColor, opacity);
    }
  }, {
    key: "drawParticle",
    value: function drawParticle(particle, delta) {
      var _this = this;

      var _a, _b, _c, _d, _e;

      if (((_a = particle.image) === null || _a === void 0 ? void 0 : _a.loaded) === false) {
        return;
      }

      var pfColor = particle.getFillColor();

      if (pfColor === undefined) {
        return;
      }

      var psColor = (_b = particle.getStrokeColor()) !== null && _b !== void 0 ? _b : pfColor;
      var options = this.container.options;
      var twinkle = particle.particlesOptions.twinkle.particles;
      var twinkleFreq = twinkle.frequency;
      var twinkleRgb = Utils_1.ColorUtils.colorToRgb(twinkle.color);
      var twinkling = twinkle.enable && Math.random() < twinkleFreq;
      var radius = (_c = particle.bubble.radius) !== null && _c !== void 0 ? _c : particle.size.value;
      var opacity = twinkling ? twinkle.opacity : (_d = particle.bubble.opacity) !== null && _d !== void 0 ? _d : particle.opacity.value;
      var infectionStage = particle.infecter.infectionStage;
      var infection = options.infection;
      var infectionStages = infection.stages;
      var infectionColor = infectionStage !== undefined ? infectionStages[infectionStage].color : undefined;
      var infectionRgb = Utils_1.ColorUtils.colorToRgb(infectionColor);
      var fColor = twinkling && twinkleRgb !== undefined ? twinkleRgb : infectionRgb !== null && infectionRgb !== void 0 ? infectionRgb : Utils_1.ColorUtils.hslToRgb(pfColor);
      var sColor = twinkling && twinkleRgb !== undefined ? twinkleRgb : infectionRgb !== null && infectionRgb !== void 0 ? infectionRgb : Utils_1.ColorUtils.hslToRgb(psColor);
      var fillColorValue = fColor !== undefined ? Utils_1.ColorUtils.getStyleFromRgb(fColor, opacity) : undefined;

      if (!this.context || !fillColorValue) {
        return;
      }

      var strokeColorValue = sColor !== undefined ? Utils_1.ColorUtils.getStyleFromRgb(sColor, (_e = particle.stroke.opacity) !== null && _e !== void 0 ? _e : opacity) : fillColorValue;

      if (particle.links.length > 0) {
        this.context.save();

        var _iterator = _createForOfIteratorHelper(particle.links),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var link = _step.value;

            if (particle.particlesOptions.links.triangles.enable) {
              (function () {
                var links = particle.links.map(function (l) {
                  return l.destination;
                });
                var vertices = link.destination.links.filter(function (t) {
                  return links.indexOf(t.destination) >= 0;
                });

                if (vertices.length) {
                  var _iterator2 = _createForOfIteratorHelper(vertices),
                      _step2;

                  try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                      var vertice = _step2.value;

                      _this.drawLinkTriangle(particle, link, vertice);
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }
                }
              })();
            }

            this.drawLinkLine(particle, link);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        this.context.restore();
      }

      if (radius > 0) {
        Utils_1.CanvasUtils.drawParticle(this.container, this.context, particle, delta, fillColorValue, strokeColorValue, options.backgroundMask.enable, radius, opacity, particle.particlesOptions.shadow);
      }
    }
  }, {
    key: "drawPlugin",
    value: function drawPlugin(plugin, delta) {
      if (!this.context) {
        return;
      }

      Utils_1.CanvasUtils.drawPlugin(this.context, plugin, delta);
    }
  }, {
    key: "paintBase",
    value: function paintBase(baseColor) {
      if (!this.context) {
        return;
      }

      Utils_1.CanvasUtils.paintBase(this.context, this.size, baseColor);
    }
  }, {
    key: "lineStyle",
    value: function lineStyle(p1, p2) {
      var options = this.container.options;
      var connectOptions = options.interactivity.modes.connect;

      if (this.context) {
        return Utils_1.CanvasUtils.gradient(this.context, p1, p2, connectOptions.links.opacity);
      }
    }
  }, {
    key: "initBackground",
    value: function initBackground() {
      var options = this.container.options;
      var background = options.background;
      var element = this.element;

      if (!element) {
        return;
      }

      var elementStyle = element.style;

      if (background.color) {
        var color = Utils_1.ColorUtils.colorToRgb(background.color);

        if (color) {
          elementStyle.backgroundColor = Utils_1.ColorUtils.getStyleFromRgb(color, background.opacity);
        }
      }

      if (background.image) {
        elementStyle.backgroundImage = background.image;
      }

      if (background.position) {
        elementStyle.backgroundPosition = background.position;
      }

      if (background.repeat) {
        elementStyle.backgroundRepeat = background.repeat;
      }

      if (background.size) {
        elementStyle.backgroundSize = background.size;
      }
    }
  }]);

  return Canvas;
}();

exports.Canvas = Canvas;